import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { actionsGenerator, asyncActions } from '@docavenue/core';
import { TlcAmcSpeciality } from '@/components/templates/TlcAmc/utils';

const tlcAmcSpecialitiesActions = actionsGenerator({
  chunkUrlResource: 'amc-tlc-specialities',
  scope: 'pat-public',
});

const useTlcAmcSpecialties = () => {
  const dispatch = useDispatch();

  return useQuery<{ items: TlcAmcSpeciality[]; total: number }>({
    queryKey: ['tlc-amc-specialties'],
    queryFn: () => asyncActions(dispatch, tlcAmcSpecialitiesActions.getList()),
  });
};

export default useTlcAmcSpecialties;
